<template>
  <div class="box">
    <div class="main-content">
      <!-- 切换功能 -->
      <div class="main-content-top">
        <!-- 课程基本信息 -->
        <div @click="information" class="information">
          <img class="informationIcon" ref="informationImg" src="../../assets/courseInformation/blueInformation.png" />
        </div>
        <!-- 教材基本信息 -->
        <div v-show="identity == 'developer'" @click="textbookInformation" class="textbookInformation">
          <img class="textbookInformationIcon" ref="textbookInformationIconImg"
            src="../../assets/courseInformation/blackTextbookInformation.png" />
        </div>
        <!-- 课程团队 -->
        <div @click="team" class="team">
          <img class="teamIcon" ref="teamImg" src="../../assets/courseInformation/blackTeam.png" />
        </div>
        <!-- 课程文件 -->
        <div @click="talent" class="talent">
          <img class="talentIcon" ref="talentImg" src="../../assets/courseInformation/blackTalent.png" />
        </div>
        <!-- 课程验收 -->
        <div @click="contentStructure" class="contentStructure">
          <img class="contentStructureIcon" ref="contentStructureImg"
            src="../../assets/courseInformation/blackContentStructure.png" />
        </div>
        <!-- 课程数据 -->
        <div @click="courseData" class="courseData">
          <img class="courseDataIcon" ref="courseDataImg" src="../../assets/courseInformation/blackCourseData.png" />
        </div>
      </div>
      <!-- 课程基本信息切换内容开始 -->
      <div v-show="changeContent1" class="change-content">
        <div class="change-contentMain">
          <!-- 课程封面部分开始 -->
          <div class="flex justify">
            <div class="flex">
              <div v-show="editableOrNot" class="requiredIcon">*</div>
              <div class="informationTxt">课程封面:</div>
            </div>
            <!-- 封面上传 -->
            <div class="coverBox">
              <img class="cover" :src="coverSrc" />
              <input v-show="editableOrNot" :value="cover_input" class="cover-input" type="file"
                accept="image/png, image/jpeg," @change="uploadWorks" />
              <div class="cover-input-txt">封面支持jpeg、png文件，建议大小800*400</div>
            </div>
            <div class="btnAffirm-box">
              <!-- <img @click="btnAffirm(0)" class="defineIcon" src="../../assets/defineIcon.png" /> -->
            </div>
          </div>
          <!-- 课程封面部分结束 -->
          <!-- 课程名称部分开始 -->
          <div class="publicMarginTop flex align justify">
            <div class="flex">
              <div v-show="editableOrNot" class="requiredIcon">*</div>
              <div class="informationTxt">课程名称:</div>
            </div>
            <div class="publicInput-box">
              <input :disabled="!editableOrNot" v-model="courseName" @click="xiu" class="publicInput" type="text"
                placeholder="请输入课程名称" />
            </div>
            <div class="btnAffirm-box">
              <!-- <img @click="btnAffirm(1)" class="defineIcon" src="../../assets/defineIcon.png" /> -->
            </div>
          </div>
          <!-- 课程名称部分结束 -->
          <!-- 课程类型部分开始 -->
          <div class="flex align justify" style="margin-top: 0.22rem">
            <div class="flex">
              <div v-show="editableOrNot" class="requiredIcon">*</div>
              <div class="informationTxt">课程类型:</div>
            </div>
            <div class="shareBox flex">
              <el-cascader :disabled="!editableOrNot" v-model="courseTypeValue" :options="courseTypeOptions"
                @change="handleChange">
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                </template>
              </el-cascader>
            </div>
            <div class="btnAffirm-box">
              <!-- <img @click="btnAffirm(2)" class="defineIcon" src="../../assets/defineIcon.png" /> -->
            </div>
          </div>
          <!-- 课程类型部分结束 -->
          <!-- 授课班级部分开始 -->
          <div class="publicMarginTop flex align justify">
            <div class="flex">
              <div v-show="editableOrNot" class="requiredIcon1">*</div>
              <div class="informationTxt">授课班级:</div>
            </div>
            <!-- 选择授课班级 -->
            <div @click="showClass" class="publicInput-box">
              <van-popover close-on-click-outside placement="bottom-start" v-model="showPopover">
                <div class="selectClass-box">
                  <div class="gradediv">
                    <div v-for="(item, index) in gradeDataList" @click="selectGrade(item)" :key="index" class="pointer">
                      <p v-if="item === gradeName" class="gradediv_color1">{{ item }}</p>
                      <p v-else class="gradediv_color2">{{ item }}</p>
                    </div>
                  </div>
                  <div class="gradediv_class">
                    <div v-for="(item, index) in classDataList" :key="index" class="gradediv_classdiv">
                      <img v-if="checkClassList.indexOf(item.id) !== -1" class="gradediv_classimg"
                        src="@/assets/classManagement/cm11.png" />
                      <img v-else class="gradediv_classimg" src="@/assets/classManagement/cm10.png" />
                      <p class="gradediv_classtxt">{{ item.name }}</p>
                    </div>
                  </div>
                </div>
                <template #reference>
                  <input class="publicInput teachingClassInput" disabled v-model="checked" placeholder="没有授课班级" />
                </template>
              </van-popover>
            </div>
            <div class="btnAffirm-box"></div>
          </div>
          <!-- 授课班级部分结束 -->
          <!-- 课次目录部分开始 -->
          <div class="publicMarginTop flex justify">
            <div class="courseCatalog-txtBox flex">
              <div v-show="editableOrNot" class="requiredIcon">*</div>
              <div class="informationTxt">课次目录:</div>
            </div>
            <div>
              <div class="classTimes-box" v-for="(item, index) in courseList" :key="index">
                <div class="classTimes-txt">课次{{ index + 1 }}</div>
                <div class="publicInput-classTimes">
                  <input :disabled="!editableOrNot" v-model="item.name" class="publicInput1" type="text"
                    placeholder="请输入课次名称" />
                </div>
                <div class="btnAffirm-box flex align">
                  <img v-show="editableOrNot" @click="deleteClasstimes(index)" class="deleteIcon pointer"
                    src="../../assets/deleteIcon.png" />
                  <img v-show="editableOrNot && hasChanged(index)" @click="reviseClasstimes(index)"
                    class="defineIcon1 pointer" src="../../assets/defineIcon.png" />
                </div>
              </div>
              <div v-show="editableOrNot" class="classTimes-box">
                <div class="classTimes-txt"></div>
                <!-- 添加课次 -->
                <div @click="addClass" class="publicInput-classTimes1 flex align pointer">
                  <div class="flex align">
                    <img src="../../assets/courseInformation/add.png" />
                    <div class="addTxt">添加课次</div>
                  </div>
                </div>
                <img class="defineIcon2" src="../../assets/defineIcon.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="changeContent1" class="flex align justify">
        <div v-show="editableOrNot" @click="btnAffirm('课程')" class="btnAffirm pointer">保存</div>
      </div>
      <!-- 课程基本信息切换内容结束 -->
      <!-- 教材基本信息切换内容开始 -->
      <div v-show="changeContent8" class="change-content">
        <div class="change-contentMain">
          <!-- 教材封面部分开始 -->
          <div class="flex justify">
            <div class="flex">
              <div v-show="editableOrNot" class="requiredIcon">*</div>
              <div class="informationTxt">教材封面:</div>
            </div>
            <!-- 封面上传 -->
            <div class="coverBox-textbook">
              <img class="cover-textbook" :src="coverSrc1" />
              <input v-show="editableOrNot" :value="cover_input1" class="cover-input-textbook" type="file"
                accept="image/png, image/jpeg," @change="uploadWorks1" />
              <div class="cover-input-txt">封面支持jpeg、png文件，建议大小800*1100</div>
            </div>
            <div class="btnAffirm-box">
              <!-- <img @click="btnAffirm(0)" class="defineIcon" src="../../assets/defineIcon.png" /> -->
            </div>
          </div>
          <!-- 教材封面部分结束 -->
          <!-- 教材名称部分开始 -->
          <div class="publicMarginTop flex align justify">
            <div class="flex">
              <div v-show="editableOrNot" class="requiredIcon">*</div>
              <div class="informationTxt">教材名称:</div>
            </div>
            <div class="publicInput-box">
              <input :disabled="!editableOrNot" v-model="textbookData.name" @click="xiu" class="publicInput" type="text"
                placeholder="请输入教材名称" />
            </div>
            <div class="btnAffirm-box">
              <!-- <img @click="btnAffirm(1)" class="defineIcon" src="../../assets/defineIcon.png" /> -->
            </div>
          </div>
          <!-- 教材名称部分结束 -->
          <!-- 主编名称部分开始 -->
          <div class="publicMarginTop flex align justify">
            <div class="flex">
              <div v-show="editableOrNot" class="requiredIcon">*</div>
              <div class="informationTxt">主编名称:</div>
            </div>
            <div class="publicInput-box">
              <input :disabled="!editableOrNot" v-model="textbookData.main_person" @click="xiu" class="publicInput"
                type="text" placeholder="请输入主编名称" />
            </div>
            <div class="btnAffirm-box">
              <!-- <img @click="btnAffirm(1)" class="defineIcon" src="../../assets/defineIcon.png" /> -->
            </div>
          </div>
          <!-- 主编名称部分结束 -->
          <!-- 教材出版社部分开始 -->
          <div class="publicMarginTop flex align justify">
            <div class="flex">
              <div v-show="editableOrNot" class="requiredIcon">*</div>
              <div class="informationTxt">出版社名称:</div>
            </div>
            <div class="publicInput-box">
              <input :disabled="!editableOrNot" v-model="textbookData.press" @click="xiu" class="publicInput"
                type="text" placeholder="请输入出版社名称" />
            </div>
            <div class="btnAffirm-box">
              <!-- <img @click="btnAffirm(1)" class="defineIcon" src="../../assets/defineIcon.png" /> -->
            </div>
          </div>
          <!-- 教材名称部分结束 -->
          <!-- 教材标签部分开始 -->
          <div class="publicMarginTop flex align justify" style="margin-top: 0.15rem">
            <div class="flex">
              <div class="asterisk" style="opacity: 0">*</div>
              <div class="informationTxt">教材标签：</div>
            </div>
            <el-select v-model="courseTagValue" multiple collapse-tags class="publicInput-box" style="border: 0"
              placeholder="请选择">
              <el-option v-for="item in courseTagOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <div class="btnAffirm-box">
              <!-- <img @click="btnAffirm(1)" class="defineIcon" src="../../assets/defineIcon.png" /> -->
            </div>
          </div>
          <!-- 教材标签部分结束 -->
          <!-- 教材类型部分开始 -->
          <div class="flex align justify" style="margin-top: 0.22rem">
            <div class="flex">
              <div v-show="editableOrNot" class="requiredIcon">*</div>
              <div class="informationTxt">教材类型:</div>
            </div>
            <div class="shareBox flex">
              <el-cascader :disabled="!editableOrNot" v-model="textbookTypeValue" :options="courseTypeOptions"
                @change="handleChange">
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                </template>
              </el-cascader>
            </div>
            <div class="btnAffirm-box">
              <!-- <img @click="btnAffirm(2)" class="defineIcon" src="../../assets/defineIcon.png" /> -->
            </div>
          </div>
          <!-- 教材类型部分结束 -->
          <!-- 课次目录部分开始 -->
          <div class="publicMarginTop flex justify">
            <div class="courseCatalog-txtBox flex">
              <div v-show="editableOrNot" class="requiredIcon">*</div>
              <div class="informationTxt">教材目录:</div>
            </div>
            <div>
              <div class="classTimes-box flex column" v-for="(item, index) in textbookCatalogueList" :key="index">
                <div class="flex align">
                  <div class="publicInput-catalogue flex">
                    <input :disabled="!editableOrNot" v-model="item.name" class="publicInput1" type="text"
                      placeholder="请输入章节名称" />
                  </div>
                  <div class="btnAffirm-box flex align">
                    <img v-show="editableOrNot" @click="deleteCatalogue(index, '')" class="deleteIcon pointer"
                      src="../../assets/deleteIcon.png" />
                    <img v-show="editableOrNot" @click="reviseCatalogue(index, '')" class="defineIcon1 pointer"
                      src="../../assets/defineIcon.png" />
                    <el-button v-show="editableOrNot" @click="addCatalogue(index)"
                      class="defineIcon1 flex align justify" type="primary" icon="el-icon-plus" circle></el-button>
                  </div>
                </div>
                <div class="publicInput-moduleBox flex column">
                  <div class="publicInput-module flex align" v-for="(items, index1) in item.items" :key="index1">
                    <div class="publicInputModule flex">
                      <input :disabled="!editableOrNot" v-model="items.name" class="publicInputModule"
                        style="margin-left: 0;" type="text" placeholder="请输入模块名称" />
                    </div>
                    <div class="btnAffirm-box flex">
                      <img v-show="editableOrNot" @click="deleteCatalogue(index, index1)" class="deleteIcon pointer"
                        src="../../assets/deleteIcon.png" />
                      <img v-show="editableOrNot" @click="reviseCatalogue(index, index1)" class="defineIcon1 pointer"
                        src="../../assets/defineIcon.png" />
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="editableOrNot" class="classTimes-box">
                <!-- 添加章节 -->
                <div @click="addCatalogue('')" class="publicInput-classTimes2 flex align pointer">
                  <div class="flex align">
                    <img src="../../assets/courseInformation/add.png" />
                    <div class="addTxt">添加章节</div>
                  </div>
                </div>
                <img class="defineIcon2" src="../../assets/defineIcon.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="changeContent8" class="flex align justify">
        <div v-show="editableOrNot" @click="btnAffirm('教材')" class="btnAffirm pointer">保存</div>
      </div>
      <!-- 教材基本信息切换内容结束 -->
      <!-- 课程团队切换内容开始 -->
      <div v-show="changeContent2" class="change-content">
        <div class="publicContent flex justify">
          <div v-show="editableOrNot" class="publicFile flex spaceBetween">
            <img @click="uploadFile('teams')" class="teamUpload" src="../../assets/courseInformation/teamUpload.png" />
            <div class="uploadTxt">只能上传doc/docx/pdf/jpeg/png文件，建议大小不超过10M</div>
          </div>
        </div>
        <div class="publicFileBox flex column align" v-for="(item, index) in courseTeamList" :key="index">
          <div v-if="fileType != 'image'" class="fileFrame flex align spaceBetween">
            <div class="publicFileBoxH flex column spaceBetween">
              <div class="fileName">{{ item.url.name }}</div>
              <div class="uploadTime">{{ item.url.date }}</div>
            </div>
            <div class="publicFunctionW flex spaceBetween">
              <img v-show="editableOrNot" @click="DownloadFile(item.url.url, item.url.name)"
                class="publicDownloadIcon pointer" src="../../assets/courseInformation/download.png" />
              <img @click="previewFile(item.url.url)" class="publicPreviewIcon pointer"
                src="../../assets/courseInformation/preview.png" />
              <img v-show="editableOrNot" @click="deleteFile('teams', item.url, index)" class="publicDeleteIcon pointer"
                src="../../assets/courseInformation/delete.png" />
            </div>
          </div>
          <img class="teamImg" v-if="fileType == 'image'" :src="item.url.url" alt="" />
        </div>
        <!-- <iframe src="https://www.jiyou-tech.com:9020/upload/20230423/2023-04-23_103518.275880074.docx" frameborder="0"></iframe> -->
      </div>
      <!-- 课程团队切换内容结束 -->
      <!-- 课程文件切换内容开始 -->
      <div v-show="changeContent3" class="change-content">
        <div class="publicContent flex justify">
          <div v-show="editableOrNot" class="publicFile flex spaceBetween">
            <img @click="uploadFile('talent_training')" class="talentUpload"
              src="../../assets/courseInformation/talentUpload.png" />
            <div class="uploadTxt">只能上传doc/docx/pdf文件，建议大小不超过10M</div>
          </div>
        </div>
        <div class="publicFileBox flex justify" v-for="(item, index) in abilityList" :key="index">
          <div class="fileFrame flex align spaceBetween">
            <div class="publicFileBoxH flex column spaceBetween">
              <div class="fileName">{{ item.url.name }}</div>
              <div class="uploadTime">{{ item.url.date }}</div>
            </div>
            <div class="publicFunctionW flex spaceBetween">
              <img v-show="editableOrNot" @click="DownloadFile(item.url.url, item.url.name)"
                class="publicDownloadIcon pointer" src="../../assets/courseInformation/download.png" />
              <img @click="previewFile(item.url.url)" class="publicPreviewIcon pointer"
                src="../../assets/courseInformation/preview.png" />
              <img v-show="editableOrNot" @click="deleteFile('talent_training', item.url, index)"
                class="publicDeleteIcon pointer" src="../../assets/courseInformation/delete.png" />
            </div>
          </div>
        </div>
      </div>
      <!-- 课程文件切换内容结束 -->
      <!-- 课程验收切换内容开始 -->
      <div v-show="changeContent6" class="change-content flex column align">
        <div class="publicFileBox1 flex column" v-for="(item, index) in contentStructureList" :key="index">
          <div class="flex align spaceBetween" style="margin-bottom: 10px">
            <div class="uploadFileTitle">{{ index + 1 }}.{{ item.title }}</div>
            <el-button v-show="identity != 'admin'" @click="uploadFile('content_struct', index)" size="small"
              type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
          </div>
          <div class="fileFrame flex align spaceBetween">
            <div v-if="item.url.url == ''" class="noFile">未上传任何资料</div>
            <div v-else class="publicFileBoxH flex column spaceBetween">
              <div class="fileName">{{ item.url.name }}</div>
              <div class="uploadTime">{{ item.url.date }}</div>
            </div>
            <div v-if="item.url.url != ''" class="publicFunctionW flex spaceBetween" style="justify-content: flex-end">
              <img @click="DownloadFile(item.url.url, item.url.name)" class="publicDownloadIcon pointer"
                src="../../assets/courseInformation/download.png" />
              <img @click="previewFile(item.url.url)" class="publicPreviewIcon pointer"
                src="../../assets/courseInformation/preview.png" />
              <img v-show="identity != 'admin'" @click="deleteFile('content_struct', item.url, index)"
                class="publicDeleteIcon pointer" src="../../assets/courseInformation/delete.png" />
            </div>
          </div>
        </div>
      </div>
      <!-- 课程验收切换内容结束 -->
      <!-- 课程数据切换内容开始 -->
      <div v-show="changeContent7" class="courseData-box">
        <div class="echarts-box">
          <div class="flex align">
            <div class="courseData-block"></div>
            <div class="courseData-title">课程统计</div>
          </div>
          <div class="echartsPieBox flex spaceBetween">
            <div class="echartsPie">
              <echartsPie ref="echartsPie1" :preData="preData[0]"></echartsPie>
            </div>
            <div class="echartsPie">
              <echartsPie ref="echartsPie2" :preData="preData[1]"></echartsPie>
            </div>
            <div class="echartsPie">
              <echartsPie ref="echartsPie3" :preData="preData[2]"></echartsPie>
            </div>
          </div>
        </div>
        <div class="flex spaceBetween" style="margin-top: 10px">
          <div class="courseInformation">
            <div class="flex align spaceBetween">
              <div class="flex align">
                <div class="courseData-block"></div>
                <div class="courseData-title">授课数据</div>
              </div>
              <el-date-picker v-model="dateValue" :clearable="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                type="daterange" @change="selectDate" unlink-panels range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期"> </el-date-picker>
            </div>
            <div class="teachingData-contentBox flex spaceBetween">
              <!-- 教师上课次数 -->
              <div class="teachingData-content flex column align spaceBetween">
                <div class="basicData-txt">教师上课次数</div>
                <div class="basicData-num">{{ teachingData.lesson_num }}</div>
              </div>
              <!-- 资源上传次数 -->
              <div class="teachingData-content flex column align spaceBetween">
                <div class="basicData-txt">资源上传次数</div>
                <div class="basicData-num">{{ teachingData.assets_num }}</div>
              </div>
              <!-- 习题上传次数 -->
              <div class="teachingData-content flex column align spaceBetween">
                <div class="basicData-txt">习题上传次数</div>
                <div class="basicData-num">{{ teachingData.exam_item_num }}</div>
              </div>
            </div>
            <div class="teachingData-contentBox1 flex spaceBetween">
              <!-- 教师发布次数 -->
              <div class="teachingData-content flex column align spaceBetween">
                <div class="basicData-txt">教师发布次数</div>
                <div class="basicData-num">{{ teachingData.publish_num }}</div>
              </div>
              <!-- 资源发布数量 -->
              <div class="teachingData-content flex column align spaceBetween">
                <div class="basicData-txt">资源发布数量</div>
                <div class="basicData-num">{{ teachingData.publish_assets_num }}</div>
              </div>
              <!-- 学生学习次数 -->
              <div class="teachingData-content flex column align spaceBetween">
                <div class="basicData-txt">学生学习次数</div>
                <div class="basicData-num">{{ teachingData.lesson_user_num }}</div>
              </div>
            </div>
          </div>
          <div class="courseInformation flex column jcs" style="border-right: 0px">
            <div class="flex align spaceBetween">
              <div class="flex align">
                <div class="courseData-block"></div>
                <div class="courseData-title">与往年数据对比</div>
              </div>
            </div>
            <div class="barChart-box flex">
              <barChart :preData="preData1" :width="preData1Width"></barChart>
              <barChart :preData="preData2" :width="preData2Width"></barChart>
            </div>
          </div>
        </div>
      </div>
      <!-- 课程数据切换内容结束 -->
    </div>
    <!-- 删除课次弹窗 -->
    <div v-show="showPopupDele" class="popup-deleClassNum flex align justify">
      <div class="popup-content flex align justify">
        <img @click="showPopupDele = false" class="popup-close pointer" src="../../assets/classManagement/cm5.png" />
        <div class="popup-txt">确定要删除吗？</div>
        <div @click="btnPopupAffirm()" class="btnPopupAffirm pointer">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { Toast } from "vant";
import "@vant/touch-emulator";
import { obtainTeacherTeachingClass, myCourseGet, reviseLesson, editLesson, courseTimesList, classAddition, courseRevision, classDeletion, addOtherInformation, delOtherInformation, gradeList, classOfGradeList, courseClassificationList, courseBasicStatisticalData, courseStatisticsData, getSingleTextbook, editTextbook, getTextbookCatalogue, addTextbookCatalogue, editTextbookCatalogue, delTextbookCatalogue } from "@/api";
import uploadFile22 from "@/utils/uploadFile22.js";
import uploadFile from "@/utils/uploadFile1.js";
import { base64toFile, filetoBase64 } from "@/utils/util.js";
// 组件
import echartsPie from "@/components/echarts_pie";
// 组件
import barChart from "@/components/echarts_pie/barChart.vue";
export default {
  setup() {
    const checked = ref([]);
    return { checked };
  },
  data() {
    return {
      editableOrNot: true, // 是否可编辑
      identity: "", // 登录身份
      coverSrc: "", // 课程封面地址
      coverSrc1: "", // 教材封面地址
      coverNet: "", // 课程封面网络路径
      coverNet1: "", // 教材封面网络路径
      cover_input: "",
      cover_input1: "",
      courseName: "", // 课程名称
      xiu1: 0,
      gender: "",
      hide: false,
      select: false, // 共享
      unSelect: true, // 不共享
      deleClassNumID: 0, // 当前删除的课次id
      deleCatalogueID: -1, // 当前删除的目录id
      showPopover: false,
      showPopupDele: false, // 控制删除课次弹窗的显示
      changeContent1: true, // 控制课程基本信息切换内容的显示
      changeContent8: false, // 控制教材基本信息切换内容的显示
      changeContent2: false, // 控制课程团队切换内容的显示
      changeContent3: false, // 控制基本信息切换内容的显示
      changeContent6: false, // 控制课程内容结构设计表的显示
      changeContent7: false, // 控制课程数据的显示
      closeChange: true, // 控制提交按钮的显示
      classListIdx: 0,
      classDataList: [], // 年级对应的班级列表
      gradeDataList: [], // 年级列表
      gradeName: "", // 默认年级名称
      checkClassList: [], // 选中的班级列表
      checked: [], // 展示选中的班级
      courseList: [], // 课程课次列表
      originalCourseList: [], // 原始课程课次列表（用于比较）
      textbookCatalogueList: [], // 教材目录列表
      courseTeamList: [], // 课程团队文件上传列表
      abilityList: [], // 人才培养方案文件上传列表
      standardList: [], // 课程标准文件上传列表
      planList: [], // 授课计划文件上传列表
      contentStructureList: [
        {
          title: "申报书",
          url: {
            name: "",
            url: "",
            date: "",
          },
        },
        {
          title: "开题汇报",
          url: {
            name: "",
            url: "",
            date: "",
          },
        },
        {
          title: "课程内容结构设计表",
          url: {
            name: "",
            url: "",
            date: "",
          },
        },
        {
          title: "课程样例",
          url: {
            name: "",
            url: "",
            date: "",
          },
        },
        {
          title: "中期汇报",
          url: {
            name: "",
            url: "",
            date: "",
          },
        },
        {
          title: "课程介绍视频",
          url: {
            name: "",
            url: "",
            date: "",
          },
        },
        {
          title: "验收汇报",
          url: {
            name: "",
            url: "",
            date: "",
          },
        },
        {
          title: "评审表",
          url: {
            name: "",
            url: "",
            date: "",
          },
        },
        {
          title: "结项证书",
          url: {
            name: "",
            url: "",
            date: "",
          },
        },
      ], // 课程内容结构设计表文件上传列表
      uploadFileType: "", // 上传文件的类型
      fileType: "", // 文件类型
      // 课程分类选项
      courseTypeOptions: [],
      courseTypeId: "", // 课程分类id
      courseTypeValue: ["专业核心课", 1], // 当前课程类型
      textbookTypeValue: [], // 当前教材类型
      preData: [
        {
          title: "资源统计",
          show: true,
          typeList: [
            { value: 0, name: "视频资源" },
            { value: 0, name: "音频资源" },
            { value: 0, name: "文档资源" },
            { value: 0, name: "图片资源" },
            { value: 0, name: "链接资源" },
          ],
          countLength: "",
        },
        {
          title: "习题统计",
          show: true,
          typeList: [
            { value: 0, name: "单选题" },
            { value: 0, name: "多选题" },
            { value: 0, name: "判断题" },
            { value: 0, name: "简答题" },
          ],
          countLength: "",
        },
        {
          title: "作业统计",
          show: true,
          typeList: [
            { value: 0, name: "手动选题" },
            { value: 0, name: "自动选题" },
          ],
          countLength: "",
        },
      ],
      dateValue: [], // 时间
      teachingData: [], // 授课数据
      preData1: [], // 柱状图数据
      preData2: [], // 柱状图数据
      preData1Width: '600px',
      preData2Width: '151px',
      textbookData: {}, // 教材基本信息
      catalogueIndex: 0, // 教材目录下标

      // 课程类型选项
      courseTagOptions: [
        {
          value: "自编教材",
          label: "自编教材",
        },
        {
          value: "市级校本教材",
          label: "市级校本教材",
        },
        {
          value: "市级规划教材",
          label: "市级规划教材",
        },
        {
          value: "市级优质教材",
          label: "市级优质教材",
        },
        {
          value: "出版教材",
          label: "出版教材",
        },
        {
          value: "国家规划教材",
          label: "国家规划教材",
        },
        {
          value: "国家优质教材",
          label: "国家优质教材",
        },
        {
          value: '“数纸一体化”教材',
          label: '“数纸一体化”教材',
        },
      ],
      courseTagValue: [], // 课程类型已选择数组
    };
  },
  components: { echartsPie, barChart },
  created() {
    // 获取登录身份
    this.identity = this.$store.state.loginRecord.data.datas.identity;
    if (this.identity == "developer") {
      // 调用单条获取教材接口
      let data = { id: this.$store.state.textbookDetails.id };
      getSingleTextbook(data).then((res) => {
        // 获取是否可编辑
        // if (this.$store.state.loginRecord.data.datas.id != res.data.datas.user_id || this.identity == "super" || this.identity == "admin") {
        //   this.$store.commit("GET_EditableOrNot", false);
        // } else {
        //   this.$store.commit("GET_EditableOrNot", true);
        // }
        this.editableOrNot = true; // 获取是否可编辑状态
        this.textbookData = res.data.datas; // 获取教材详情
        this.courseTagValue = res.data.datas.levels;
        this.coverSrc1 = res.data.datas.pics[0]; // 获取课程封面
        this.coverNet1 = res.data.datas.pics[0];
        this.textbookTypeValue[0] = res.data.datas.category?.types;
        this.textbookTypeValue[1] = res.data.datas.category?.id;
        this.courseTypeId = res.data.datas.category?.id;
        // 调用获取教材目录接口
        let params = { book_id: res.data.datas.id };
        getTextbookCatalogue(params).then((res) => {
          if (res.data.code == 0) {
            this.textbookCatalogueList = res.data.datas;
          }
        });
      });
    }
    if (this.$store.state.courseDetails) {
      // 调用获取老师授课班级列表接口
      let params2 = { lesson_id: this.$store.state.courseDetails.id };
      obtainTeacherTeachingClass(params2).then((res) => {
        this.checked = res.data.datas.map((obj) => obj.name); // 获取老师授课班级列表
        this.checkClassList = res.data.datas.map((obj) => obj.id);
      });
      // 调用获取年级列表接口
      gradeList().then((res) => {
        this.gradeDataList = res.data.datas; // 获取年级列表
        this.gradeName = res.data.datas[0];
        // 调用获取对应年级的班级列表
        let params = { grade: res.data.datas[0] };
        classOfGradeList(params).then((res) => {
          this.classDataList = res.data.datas;
        });
      });
      // 获取课程详情
      let params = {
        where: [{ k: "id", v: this.$store.state.courseDetails.id, op: "=" }],
      };
      myCourseGet(params).then((res) => {
        // 获取是否可编辑
        if (this.identity == "developer") {
          this.editableOrNot = true;
        } else {
          if (this.$store.state.loginRecord.data.datas.id != res.data.datas.user_id || this.identity == "super") {
            this.$store.commit("GET_EditableOrNot", false);
          } else {
            this.$store.commit("GET_EditableOrNot", true);
          }
          this.editableOrNot = this.$store.state.editableOrNot; // 获取是否可编辑状态
        }
        let publicData = res.data.datas;
        this.courseTypeValue[0] = publicData.category?.types;
        this.courseTypeValue[1] = publicData.category?.id;
        this.coverSrc = publicData.pics[0]; // 获取课程封面
        this.courseName = publicData.name; // 获取课程名称
        if (publicData.shared) {
          this.select = true;
          this.unSelect = false;
        } else {
          this.select = false;
          this.unSelect = true;
        }
        this.hide = false;
        // 课程团队文件
        for (let i in publicData.teams) {
          publicData.teams[i].url = JSON.parse(publicData.teams[i].url);
          // console.log(publicData.teams[0].url.name);
          if (this.isImage(publicData.teams[0].url.name)) {
            this.fileType = "image";
          } else {
            this.fileType = "";
          }
        }
        // 人才培养方案
        for (let i in publicData.talent_training) {
          publicData.talent_training[i].url = JSON.parse(publicData.talent_training[i].url);
        }
        // 课程标准
        for (let i in publicData.course_info) {
          publicData.course_info[i].url = JSON.parse(publicData.course_info[i].url);
        }
        // 授课计划
        for (let i in publicData.lesson_plan) {
          publicData.lesson_plan[i].url = JSON.parse(publicData.lesson_plan[i].url);
        }
        // 课程内容结构设计表
        for (let i in publicData.content_struct) {
          this.contentStructureList[i].url = JSON.parse(publicData.content_struct[i].url);
        }
        // console.log(JSON.parse(publicData.teams[0].url));
        this.courseTeamList = publicData.teams || []; // 获取课程团队文件上传列表
        this.abilityList = publicData.talent_training || []; // 获取人才培养方案文件上传列表
        this.standardList = publicData.course_info || []; // 获取课程标准文件上传列表
        this.planList = publicData.lesson_plan || []; // 获取授课计划文件上传列表
        // this.contentStructureList = publicData.content_struct || []; // 获取课程内容结构设计表文件上传列表
      });
      // 获取课程课次
      let params1 = { lesson_id: this.$store.state.courseDetails.id };
      courseTimesList(params1).then((res) => {
        this.courseList = res.data.datas;
        // 保存原始课次列表，用于后续比较
        this.originalCourseList = JSON.parse(JSON.stringify(res.data.datas));
        this.$store.commit("GET_ClassListRecord", res.data.datas);
      });
      const result = this.getRecentSevenDays();
      let str1 = result.start.split(" ")[0];
      let str2 = result.end.split(" ")[0];
      this.dateValue[0] = str1; // 获取默认时间
      this.dateValue[1] = str2;
      // 调用课程次数统计数据接口
      let params3 = { lesson_id: this.$store.state.courseDetails.id, begin: result.start, end: result.end };
      courseStatisticsData(params3).then((res) => {
        if (res.data.code == 0) {
          this.teachingData = res.data.datas; // 获取授课数据
        }
      });
      // 调用课程基础统计数据接口
      let params4 = { lesson_id: this.$store.state.courseDetails.id };
      courseBasicStatisticalData(params4).then((res) => {
        if (res.data.code == 0) {
          let publicData = res.data.datas;
          this.preData[0].typeList[0].value = publicData.aseets_video_num;
          this.preData[0].typeList[1].value = publicData.aseets_audio_num;
          this.preData[0].typeList[2].value = publicData.aseets_doc_num;
          this.preData[0].typeList[3].value = publicData.aseets_image_num;
          this.preData[0].typeList[4].value = publicData.aseets_web_num;
          this.preData[1].typeList[0].value = publicData.examitem_single_num;
          this.preData[1].typeList[1].value = publicData.examitem_multi_num;
          this.preData[1].typeList[2].value = publicData.examitem_truefalse_num;
          this.preData[1].typeList[3].value = publicData.examitem_answer_num;
          this.preData[2].typeList[0].value = publicData.exam_manual_num;
          this.preData[2].typeList[1].value = publicData.exam_auto_num;
          let num1 = publicData.aseets_video_num + publicData.aseets_audio_num + publicData.aseets_doc_num + publicData.aseets_image_num + publicData.aseets_web_num;
          this.preData[0].countLength = "{totalText|共计}" + "\n" + "{totalText|" + (num1 + 1 - 1) + "个}";
          let num2 = publicData.examitem_single_num + publicData.examitem_multi_num + publicData.examitem_truefalse_num + publicData.examitem_answer_num;
          this.preData[1].countLength = "{totalText|共计}" + "\n" + "{totalText|" + num2 + "个}";
          let num3 = publicData.exam_manual_num + publicData.exam_auto_num;
          this.preData[2].countLength = "{totalText|共计}" + "\n" + "{totalText|" + num3 + "个}";
          this.preData1 = [
            { product: "教师上课次数", 往年: publicData.lastyear_lesson_num, 今年: publicData.thisyear_lesson_num },
            { product: "资源上传次数", 往年: publicData.lastyear_assets_num, 今年: publicData.thisyear_assets_num },
            { product: "习题上传次数", 往年: publicData.lastyear_exam_item_num, 今年: publicData.thisyear_exam_item_num },
            { product: "教师发布次数", 往年: publicData.lastyear_publish_num, 今年: publicData.thisyear_publish_num },
            { product: "资源发布数量", 往年: publicData.lastyear_publish_assets_num, 今年: publicData.thisyear_publish_assets_num },
          ];
          this.preData2 = [
            { product: "学生学习次数", 往年: publicData.lastyear_lesson_user_num, 今年: publicData.thisyear_lesson_user_num },
          ];
        }
      });
    }
    // 调用课程分类列表接口
    courseClassificationList().then((res) => {
      // 第一步：根据types字段分组，并构建新的树状结构
      const groupedData = res.data.datas.reduce((acc, item) => {
        const { types, id, name } = item;
        if (!acc[types]) {
          acc[types] = {
            value: types,
            label: types,
            children: [],
          };
        }
        acc[types].children.push({
          value: id,
          label: name,
        });
        return acc;
      }, {});

      // 第二步：将分组后的对象数组转换为数组
      const transformedData = Object.values(groupedData);

      // 第三步：按照label字段进行排序
      this.courseTypeOptions = transformedData.sort((a, b) => {
        // 如果需要按照升序排序，则返回 a.label - b.label
        // 如果需要按照降序排序，则返回 b.label - a.label
        return b.label - a.label;
      });
    });
  },
  methods: {
    // 选择日期
    selectDate() {
      // 调用课程次数统计数据接口
      let params = { lesson_id: this.$store.state.courseDetails.id, begin: this.dateValue[0] + " 00:00:00", end: this.dateValue[1] + " 23:59:59" };
      courseStatisticsData(params).then((res) => {
        if (res.data.code == 0) {
          this.teachingData = res.data.datas; // 获取授课数据
        }
      });
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // getMonth()返回的月份是从0开始的，所以需要+1
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${year}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day} ${hours}:${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
    },
    getRecentSevenDays() {
      const today = new Date();
      const start = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000); // 7天前的时间
      const end = new Date(today.getTime()); // 今天的时间
      let startFormatted = this.formatDate(start);
      let endFormatted = this.formatDate(end);
      return { start: startFormatted, end: endFormatted };
    },
    // 课程类型选择方法
    handleChange(value) {
      this.courseTypeId = value[1];
    },
    // 从班级库新增选择年级
    selectGrade(gradeName) {
      this.gradeName = gradeName;
      // 调用获取对应年级的班级列表
      let params = { grade: gradeName };
      classOfGradeList(params).then((res) => {
        this.classDataList = res.data.datas;
      });
    },
    // 判断是否为图片
    isImage(filename) {
      const extension = filename.toLowerCase().split(".").pop();
      return ["jpeg", "jpg", "png", "gif"].includes(extension);
    },
    xiu() {
      this.hide = true;
    },
    // 上传课程封面
    uploadWorks(e) {
      this.hide = true;
      var file = e.target.files[0];
      this.cover_input = ""; // input标签的change触发规则
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (res) => {
        this.coverSrc = res.target.result;
        let str1 = base64toFile(this.coverSrc, "file"); //base64图片格式转文件流
        let formData = new FormData();
        formData.append("file", str1);
        uploadFile(formData).then((res) => {
          this.coverNet = res.datas;
        });
      };
      reader.readAsDataURL(file);
    },
    // 上传教材封面
    uploadWorks1(e) {
      this.hide = true;
      var file = e.target.files[0];
      this.cover_input1 = ""; // input标签的change触发规则
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (res) => {
        this.coverSrc1 = res.target.result;
        let str1 = base64toFile(this.coverSrc1, "file"); //base64图片格式转文件流
        let formData = new FormData();
        formData.append("file", str1);
        uploadFile(formData).then((res) => {
          this.coverNet1 = res.datas;
        });
      };
      reader.readAsDataURL(file);
    },
    // 分享
    share() {
      this.hide = true;
      this.select = true;
      this.unSelect = false;
    },
    // 不分享
    notShare() {
      this.hide = true;
      this.select = false;
      this.unSelect = true;
    },
    showClass() {
      this.showPopover = true;
    },
    // 添加课次
    addClass() {
      this.xiu1++;
      if (this.courseList[this.courseList.length - 1].name == "") {
        Toast("请先填写上一课次！");
      } else {
        if (this.courseList[this.courseList.length - 1].name != "" && this.xiu1 != 1) {
          let xiu = {
            name: "",
          };
          this.courseList.push(xiu);
          // 确保originalCourseList与courseList长度一致，使用$set确保响应式
          if (!this.originalCourseList[this.courseList.length - 1]) {
            this.$set(this.originalCourseList, this.courseList.length - 1, JSON.parse(JSON.stringify(xiu)));
          }
        } else {
          let xiu = {
            name: "",
          };
          this.courseList.push(xiu);
          // 确保originalCourseList与courseList长度一致，使用$set确保响应式
          if (!this.originalCourseList[this.courseList.length - 1]) {
            this.$set(this.originalCourseList, this.courseList.length - 1, JSON.parse(JSON.stringify(xiu)));
          }
        }
      }
    },
    // 添加教材目录
    addCatalogue(index) {
      if (index === "") {
        this.catalogueIndex++;
        if (this.textbookCatalogueList.length != 0) {
          if (this.textbookCatalogueList[this.textbookCatalogueList.length - 1].name == "") {
            Toast("请先填写上一章节名称！");
          } else {
            this.textbookCatalogueList.push({ name: "" });
          }
        } else {
          this.textbookCatalogueList.push({ name: "" });
        }
      } else {
        if (!this.textbookCatalogueList[index].items) {
          this.textbookCatalogueList[index].items = [];
          this.textbookCatalogueList[index].items?.push({ name: "" });
        } else {
          if (this.textbookCatalogueList[index].items?.length != 0) {
            if (this.textbookCatalogueList[index].items[this.textbookCatalogueList[index].items?.length - 1]?.name == "") {
              Toast("请先填写上一模块名称！");
            } else {
              this.textbookCatalogueList[index].items?.push({ name: "" });
            }
          } else {
            this.textbookCatalogueList[index].items?.push({ name: "" });
          }
          console.log(this.textbookCatalogueList);
        }
        this.$forceUpdate();
      }
    },
    // 提交数据按钮
    btnAffirm(type) {
      if (type == "课程") {
        // 检查是否有课次更新了但未保存
        let hasUnsavedChanges = false;
        for (let i = 0; i < this.courseList.length; i++) {
          if (this.hasChanged(i)) {
            hasUnsavedChanges = true;
            break;
          }
        }
        if (hasUnsavedChanges) {
          this.$alert('课次有未保存的更新，请先保存课次变更！', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
          });
          return;
        }
        if (this.coverSrc != "" && this.courseName != "") {
          let data = { id: this.$store.state.courseDetails.id, pics: this.coverNet, name: this.courseName, shared: this.select, category_id: this.courseTypeId };
          reviseLesson(data).then((res) => {
            if (res.data.code == 0) {
              Toast("已保存！");
            }
          });
        } else {
          if (this.courseName == "") {
            Toast("请输入课程名称！");
          }
        }
      } else if (type == "教材") {
        if (this.coverSrc1 != "" && this.textbookData.name != "") {
          let data = { id: this.$store.state.textbookDetails.id, pics: [this.coverNet1], name: this.textbookData.name, press: this.textbookData.press, main_person: this.textbookData.main_person, category_id: this.courseTypeId, levels: this.courseTagValue };
          editTextbook(data).then((res) => {
            if (res.data.code == 0) {
              Toast("已保存！");
            }
          });
        } else {
          if (this.textbookData.name == "") {
            Toast("请输入教材名称！");
          }
        }
      }
    },
    // 删除课次
    deleteClasstimes(idx) {
      if (this.courseList.length == 1) {
        Toast("最后一个课次不能删除！");
      } else {
        this.deleClassNumID = idx;
        this.showPopupDele = true;
      }
    },

    // 删除目录
    deleteCatalogue(idx, idx1) {
      if (idx1 == "") {
        if (this.textbookCatalogueList.length == 1) {
          Toast("最后一个目录不能删除！");
        } else {
          this.deleClassNumID = idx;
          this.deleCatalogueID = -1;
          this.showPopupDele = true;
        }
      } else {
        if (this.textbookCatalogueList.length == 1) {
          Toast("最后一个目录不能删除！");
        } else {
          this.deleClassNumID = idx;
          this.deleCatalogueID = idx1;
          this.showPopupDele = true;
        }
      }
    },
    // 删除弹窗确定按钮
    btnPopupAffirm() {
      if (this.changeContent1) {
        let data = { id: this.courseList[this.deleClassNumID].id };
        classDeletion(data).then((res) => {
          this.courseList.splice(this.deleClassNumID, 1);
          this.showPopupDele = false;
        });
      } else if (this.changeContent8) {
        if (this.deleCatalogueID == -1) {
          let data = { id: this.textbookCatalogueList[this.deleClassNumID].id };
          delTextbookCatalogue(data).then((res) => {
            this.textbookCatalogueList.splice(this.deleClassNumID, 1);
            this.showPopupDele = false;
          });
        } else {
          let data = { id: this.textbookCatalogueList[this.deleClassNumID].items[this.deleCatalogueID].id };
          delTextbookCatalogue(data).then((res) => {
            this.textbookCatalogueList[this.deleClassNumID].items.splice(this.deleCatalogueID, 1);
            this.showPopupDele = false;
          });
        }
      }
    },
    // 修改课次
    reviseClasstimes(idx) {
      if (this.courseList[idx].name !== "") {
        if (this.courseList[idx].id) {
          let data = { id: this.courseList[idx].id, name: this.courseList[idx].name };
          courseRevision(data).then((res) => {
            if (res.data.code == 0) {
              Toast("已修改！");
              // 使用$set确保响应式更新，使图标重新隐藏
              this.$set(this.originalCourseList, idx, JSON.parse(JSON.stringify(this.courseList[idx])));
            }
          });
        } else {
          let data = { lesson_id: this.$store.state.courseDetails.id, name: this.courseList[idx].name };
          classAddition(data).then((res) => {
            this.courseList[idx].id = res.data.datas.id;
            Toast("已上传课次！");
            // 使用$set确保响应式更新，使图标重新隐藏
            this.$set(this.originalCourseList, idx, JSON.parse(JSON.stringify(this.courseList[idx])));
          });
        }
      } else {
        Toast("请输入课次名称！");
      }
    },
    // 判断课次是否有变化
    hasChanged(idx) {
      // 新添加的课次（没有id）或值有变化时返回true
      if (!this.originalCourseList[idx]) {
        return this.courseList[idx].name !== "";
      }
      return this.courseList[idx].name !== this.originalCourseList[idx].name;
    },
    // 修改或添加教材目录
    reviseCatalogue(idx, idx1) {
      console.log(idx, this.textbookCatalogueList[idx]);
      if (idx1 === "") {
        if (this.textbookCatalogueList[idx].name !== "") {
          if (this.textbookCatalogueList[idx].id) {
            let data = { book_id: this.$store.state.textbookDetails.id, id: this.textbookCatalogueList[idx].id, name: this.textbookCatalogueList[idx].name };
            editTextbookCatalogue(data).then((res) => {
              if (res.data.code == 0) {
                Toast("已修改！");
              }
            });
          } else {
            let data = { book_id: this.$store.state.textbookDetails.id, parent_id: this.textbookCatalogueList[idx].id, name: this.textbookCatalogueList[idx].name };
            addTextbookCatalogue(data).then((res) => {
              this.textbookCatalogueList[idx].id = res.data.datas.id;
              Toast("已上传目录！");
            });
          }
        } else {
          Toast("请输入目录名称！");
        }
      } else {
        if (this.textbookCatalogueList[idx].items[idx1].name !== "") {
          if (this.textbookCatalogueList[idx].items[idx1].id) {
            let data = { book_id: this.$store.state.textbookDetails.id, id: this.textbookCatalogueList[idx].items[idx1].id, name: this.textbookCatalogueList[idx].items[idx1].name };
            editTextbookCatalogue(data).then((res) => {
              if (res.data.code == 0) {
                Toast("已修改！");
              }
            });
          } else {
            let data = { book_id: this.$store.state.textbookDetails.id, parent_id: this.textbookCatalogueList[idx].id, name: this.textbookCatalogueList[idx].items[idx1].name };
            addTextbookCatalogue(data).then((res) => {
              this.textbookCatalogueList[idx].id = res.data.datas.parent_id;
              Toast("已上传模块！");
            });
          }
        } else {
          Toast("请输入模块名称！");
        }
      }
    },
    // 课程基本信息
    information() {
      this.$refs.informationImg.src = require("../../assets/courseInformation/blueInformation.png");
      this.$refs.textbookInformationIconImg.src = require("../../assets/courseInformation/blackTextbookInformation.png");
      this.$refs.teamImg.src = require("../../assets/courseInformation/blackTeam.png");
      this.$refs.talentImg.src = require("../../assets/courseInformation/blackTalent.png");
      this.$refs.contentStructureImg.src = require("../../assets/courseInformation/blackContentStructure.png");
      this.$refs.courseDataImg.src = require("../../assets/courseInformation/blackCourseData.png");
      this.changeContent1 = true;
      this.changeContent8 = false;
      this.changeContent2 = false;
      this.changeContent3 = false;
      this.changeContent6 = false;
      this.changeContent7 = false;
    },
    // 教材基本信息
    textbookInformation() {
      this.$refs.informationImg.src = require("../../assets/courseInformation/blackInformation.png");
      this.$refs.textbookInformationIconImg.src = require("../../assets/courseInformation/blueTextbookInformation.png");
      this.$refs.teamImg.src = require("../../assets/courseInformation/blackTeam.png");
      this.$refs.talentImg.src = require("../../assets/courseInformation/blackTalent.png");
      this.$refs.contentStructureImg.src = require("../../assets/courseInformation/blackContentStructure.png");
      this.$refs.courseDataImg.src = require("../../assets/courseInformation/blackCourseData.png");
      this.changeContent1 = false;
      this.changeContent8 = true;
      this.changeContent2 = false;
      this.changeContent3 = false;
      this.changeContent6 = false;
      this.changeContent7 = false;
    },
    // 课程团队
    team() {
      this.$refs.informationImg.src = require("../../assets/courseInformation/blackInformation.png");
      this.$refs.textbookInformationIconImg.src = require("../../assets/courseInformation/blackTextbookInformation.png");
      this.$refs.teamImg.src = require("../../assets/courseInformation/blueTeam.png");
      this.$refs.talentImg.src = require("../../assets/courseInformation/blackTalent.png");
      this.$refs.contentStructureImg.src = require("../../assets/courseInformation/blackContentStructure.png");
      this.$refs.courseDataImg.src = require("../../assets/courseInformation/blackCourseData.png");
      this.changeContent1 = false;
      this.changeContent8 = false;
      this.changeContent2 = true;
      this.changeContent3 = false;
      this.changeContent6 = false;
      this.changeContent7 = false;
    },
    // 课程文件
    talent() {
      this.$refs.informationImg.src = require("../../assets/courseInformation/blackInformation.png");
      this.$refs.textbookInformationIconImg.src = require("../../assets/courseInformation/blackTextbookInformation.png");
      this.$refs.teamImg.src = require("../../assets/courseInformation/blackTeam.png");
      this.$refs.talentImg.src = require("../../assets/courseInformation/blueTalent.png");
      this.$refs.contentStructureImg.src = require("../../assets/courseInformation/blackContentStructure.png");
      this.$refs.courseDataImg.src = require("../../assets/courseInformation/blackCourseData.png");
      this.changeContent1 = false;
      this.changeContent8 = false;
      this.changeContent2 = false;
      this.changeContent3 = true;
      this.changeContent6 = false;
      this.changeContent7 = false;
    },
    // 课程内容结构设计表
    contentStructure() {
      this.$refs.informationImg.src = require("../../assets/courseInformation/blackInformation.png");
      this.$refs.textbookInformationIconImg.src = require("../../assets/courseInformation/blackTextbookInformation.png");
      this.$refs.teamImg.src = require("../../assets/courseInformation/blackTeam.png");
      this.$refs.talentImg.src = require("../../assets/courseInformation/blackTalent.png");
      this.$refs.contentStructureImg.src = require("../../assets/courseInformation/blueContentStructure.png");
      this.$refs.courseDataImg.src = require("../../assets/courseInformation/blackCourseData.png");
      this.changeContent1 = false;
      this.changeContent8 = false;
      this.changeContent2 = false;
      this.changeContent3 = false;
      this.changeContent6 = true;
      this.changeContent7 = false;
    },
    // 课程数据
    courseData() {
      this.$refs.informationImg.src = require("../../assets/courseInformation/blackInformation.png");
      this.$refs.textbookInformationIconImg.src = require("../../assets/courseInformation/blackTextbookInformation.png");
      this.$refs.teamImg.src = require("../../assets/courseInformation/blackTeam.png");
      this.$refs.talentImg.src = require("../../assets/courseInformation/blackTalent.png");
      this.$refs.contentStructureImg.src = require("../../assets/courseInformation/blackContentStructure.png");
      this.$refs.courseDataImg.src = require("../../assets/courseInformation/blueCourseData.png");
      this.changeContent1 = false;
      this.changeContent8 = false;
      this.changeContent2 = false;
      this.changeContent3 = false;
      this.changeContent6 = false;
      this.changeContent7 = true;
    },
    // 上传文件 1.课程团队 2.人才培养方案 3.课程标准 4.授课计划
    uploadFile(type, index) {
      this.fileIndex = index;
      // console.log(type);
      this.uploadFileType = type;
      let inputAccept = "";
      if (type == "teams") {
        inputAccept = "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,image/jpeg,image/png";
      } else if (type == "talent_training") {
        inputAccept = "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf";
      } else if (type == "course_info") {
        inputAccept = "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf";
      } else if (type == "lesson_plan") {
        inputAccept = "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf";
      } else if (type == "content_struct") {
        inputAccept = "*";
      }
      let params = {
        accept: inputAccept, //上传的文件类型
        // onUploadProgress: this.onUploadProgress, //上传进度回调
        uploadSuccess: this.uploadSuccess, //上传成功回调
      };
      uploadFile22(params)
        .then(({ file, ext }) => {
          console.log(file.type);
          this.fileType = file.type.split("/")[0];
          filetoBase64(file).then((base64) => {
            // console.log(base64);
          });
        })
        .catch((error) => {
          alert(error);
        });
    },
    //上传成功
    uploadSuccess({ data }) {
      // console.log(data);
      let getDate = new Date();
      let year = getDate.getFullYear(); // 获取当前时间的年份
      let month = getDate.getMonth() + 1; // 获取当前时间的月份
      let day = getDate.getDate(); // 获取当前时间的日期
      let date = year + "年" + month + "月" + day + "日"; // 组合年月日
      let uploadFileDatas = {}; // 上传文件的数据
      uploadFileDatas.name = data.ext;
      uploadFileDatas.date = date;
      uploadFileDatas.url = data.datas;
      // console.log(uploadFileDatas);
      if (this.uploadFileType == "content_struct") {
        this.contentStructureList[this.fileIndex].url = uploadFileDatas;
        let params = { id: this.$store.state.courseDetails.id, content_struct: "" };
        editLesson(params).then((res) => {
          if (res.data.code == 0) {
            let index = 0;
            this.publicUploadFile(index);
          } else {
            Toast("上传失败！");
          }
        });
      } else {
        let data1 = {
          id: this.$store.state.courseDetails.id,
          cloum_name: this.uploadFileType,
          url: JSON.stringify(uploadFileDatas),
        };
        addOtherInformation(data1).then((res) => {
          if (res.data.code == 0) {
            Toast("上传成功！");
            if (this.uploadFileType == "teams") {
              for (let i in this.courseTeamList) {
                let data = {
                  id: this.$store.state.courseDetails.id,
                  cloum_name: "teams",
                  url: JSON.stringify(this.courseTeamList[i].url),
                };
                delOtherInformation(data).then((res) => { });
              }
              this.courseTeamList = [];
              let uploadFileDatasList = {};
              uploadFileDatasList.url = uploadFileDatas;
              console.log(uploadFileDatasList);
              this.courseTeamList.push(uploadFileDatasList);
            } else if (this.uploadFileType == "talent_training") {
              let uploadFileDatasList = {};
              uploadFileDatasList.url = uploadFileDatas;
              this.abilityList.push(uploadFileDatasList);
            } else if (this.uploadFileType == "course_info") {
              let uploadFileDatasList = {};
              uploadFileDatasList.url = uploadFileDatas;
              this.standardList.push(uploadFileDatasList);
            } else if (this.uploadFileType == "lesson_plan") {
              let uploadFileDatasList = {};
              uploadFileDatasList.url = uploadFileDatas;
              this.planList.push(uploadFileDatasList);
            } else if (this.uploadFileType == "content_struct") {
              let uploadFileDatasList = {};
              uploadFileDatasList.url = uploadFileDatas;
              this.contentStructureList.push(uploadFileDatasList);
            }
          }
          console.log(res.data);
        });
      }
    },
    publicUploadFile(index) {
      let data = {
        id: this.$store.state.courseDetails.id,
        cloum_name: "content_struct",
        url: JSON.stringify(this.contentStructureList[index].url),
      };
      addOtherInformation(data).then((res) => {
        if (res.data.code == 0) {
          if (index == this.contentStructureList.length - 1) return;
          index++;
          this.publicUploadFile(index);
        }
      });
    },
    // 下载文件
    DownloadFile(fileUrl, fileName) {
      const x = new window.XMLHttpRequest();
      x.open("GET", fileUrl, true);
      x.responseType = "blob";
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = fileName;
        a.style.display = "none";
        document.body.append(a);
        a.click();
      };
      x.send();
    },
    // 预览文件
    previewFile(fileUrl) {
      window.open(fileUrl);
    },
    // 删除文件
    deleteFile(type, url, idx) {
      console.log(JSON.stringify(url));
      let data = { id: this.$store.state.courseDetails.id, cloum_name: type, url: JSON.stringify(url) };
      delOtherInformation(data).then((res) => {
        if (res.data.code == 0) {
          Toast("已删除！");
          if (type == "teams") {
            this.courseTeamList.splice(idx, 1);
          } else if (type == "talent_training") {
            this.abilityList.splice(idx, 1);
          } else if (type == "course_info") {
            this.standardList.splice(idx, 1);
          } else if (type == "lesson_plan") {
            this.planList.splice(idx, 1);
          } else if (type == "content_struct") {
            // this.contentStructureList.splice(idx, 1);
            this.contentStructureList[idx].url = { name: "", url: "", date: "" };
            let params = { id: this.$store.state.courseDetails.id, content_struct: "" };
            editLesson(params).then((res) => {
              if (res.data.code == 0) {
                let index = 0;
                this.publicUploadFile(index);
              } else {
                Toast("上传失败！");
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

.flex {
  display: flex;
}

.column {
  flex-direction: column;
}

.align {
  align-items: center;
}

.justify {
  justify-content: center;
}

.spaceBetween {
  justify-content: space-between;
}

.box {
  width: 100%;
  height: 100%;
  display: flex;
}

.main-content {
  width: 1740px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
}

::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}

.main-content-top {
  width: 1740px;
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bfbfbf;
}

.informationIcon {
  width: 194px;
  height: 24px;
}

.textbookInformationIcon {
  width: 188px;
  height: 24px;
}

.teamIcon {
  width: 144px;
  height: 24px;
}

.talentIcon {
  width: 136px;
  height: 24px;
}

.standardIcon {
  width: 137px;
  height: 24px;
}

.planIcon {
  width: 136px;
  height: 24px;
}

.contentStructureIcon {
  width: 143px;
  height: 24px;
}

.courseDataIcon {
  width: 141px;
  height: 24px;
}

.information {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.textbookInformation {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  cursor: pointer;
  border-left: 1px solid #bfbfbf;
}

.team {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  border-left: 1px solid #bfbfbf;
  border-right: 1px solid #bfbfbf;
  cursor: pointer;
}

.talent {
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #bfbfbf;
  height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.standard {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  border-left: 1px solid #bfbfbf;
  border-right: 1px solid #bfbfbf;
  cursor: pointer;
}

.plan {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #bfbfbf;
  cursor: pointer;
}

.contentStructure {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #bfbfbf;
  height: 40px;
}

.courseData {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.change-content {
  width: 1740px;
  height: calc(100vh - 300px);
  padding: 10px;
  box-sizing: border-box;
  overflow: auto;
}

.publicContent {
  width: 1740px;
}

.publicFile {
  width: 1401px;
  margin-top: 30px;
}

.publicFileBox {
  width: 1740px;
  overflow: auto;
  margin-top: 10px;
}

.publicFileBox1 {
  width: 1400px;
  margin-top: 40px;
}

.uploadFileTitle {

  font-weight: 400;
  font-size: 22px;
  color: #349afe;
  line-height: 22px;
}

.publicFileBoxH {
  height: 69px;
}

.publicFunctionW {
  width: 260px;
}

.teamUpload {
  width: 145px;
  height: 18px;
  cursor: pointer;
}

.talentUpload {
  width: 500px;
  height: 20px;
  cursor: pointer;
}

.standardUpload {
  width: 145px;
  height: 18px;
  cursor: pointer;
}

.planUpload {
  width: 145px;
  height: 18px;
  cursor: pointer;
}

.contentStructureUpload {
  width: 246px;
  height: 19px;
  cursor: pointer;
}

.publicDownloadIcon {
  margin-right: 20px;
  width: 65px;
  height: 18px;
}

.publicPreviewIcon {
  margin-right: 20px;
  width: 68px;
  height: 19px;
}

.publicDeleteIcon {
  width: 68px;
  height: 20px;
}

.teamImg {
  width: 1200px;
}

.change-contentMain {
  height: calc(100vh - 340px);
  overflow: auto;
  margin-top: 20px;
}

.publicMarginTop {
  margin-top: 30px;
}

.courseCatalog-txtBox {
  margin-top: 15px;
}

.requiredIcon {
  width: 10px;
  height: 10px;
  color: #ff0000;
}

.requiredIcon1 {
  opacity: 0;
}

.informationTxt {
  font-size: 18px;

  font-weight: 400;
  line-height: 18px;
  color: #555555;
}

.shareBox {
  width: 761px;
  margin-left: 35px;
}

.noShare {
  margin-left: 38px;
}

.coverBox {
  width: 761px;
  height: 169px;
  position: relative;
  margin-left: 33px;
}

.coverBox-textbook {
  width: 761px;
  position: relative;
  margin-left: 33px;
}

.cover {
  width: 270px;
  height: 135px;
  border-radius: 10px;
  object-fit: cover;
}

.cover-textbook {
  width: 160px;
  height: 222px;
  border-radius: 10px;
  object-fit: cover;
}

.cover-input {
  position: absolute;
  left: 0;
  width: 270px;
  height: 135px;
  border-radius: 10px;
  opacity: 0;
  border: 0px;
  outline: none;
}

.cover-input-textbook {
  position: absolute;
  left: 0;
  width: 160px;
  height: 222px;
  border-radius: 10px;
  opacity: 0;
  border: 0px;
  outline: none;
}

.cover-input-txt {
  margin-top: 15px;
  font-size: 16px;

  font-weight: 400;
  color: #b6b6b6;
}

// 公共输入框样式
.publicInput-box {
  margin-left: 33px;
  width: 761px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
}

.publicInput {
  font-size: 18px;

  font-weight: 400;
  color: #555555;
  margin-left: 17px;
  width: 500px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.teachingClassInput {
  width: 709px;
}

.publicInput1 {
  font-size: 20px;

  font-weight: 400;
  color: #555555;
  margin-left: 17px;
  width: 500px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
  background-color: transparent;
  border: 0px;
  outline: none;
}

/* 自定义placeholder的默认样式 */
input::-webkit-input-placeholder {
  color: #666666;
}

#radio1,
#radio2 {
  display: none;
}

.radioInput {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid #b6b6b6;
  border-radius: 50%;
}

.selectIcon {
  width: 12px;
  height: 12px;
  background: #349afe;
  border-radius: 50%;
}

.unSelectIcon {
  width: 8px;
  height: 8px;
  border: 2px solid #b6b6b6;
  border-radius: 50%;
}

.selectTxt {
  font-size: 20px;

  font-weight: 400;
  color: #349afe;
  margin-left: 4px;
}

.unSelectTxt {
  font-size: 20px;

  font-weight: 400;
  color: #b9b9b9;
  margin-left: 4px;
}

// 选择班级组件
.selectClass-box {
  width: 761px;
  height: 246px;
  overflow: auto;
}

.selectClass-box-top {
  padding: 15px 47px;
  width: 761px;
  height: 50px;
  background: #f5f5f5;
  box-sizing: border-box;
}

.selectClassTxt {
  font-size: 20px;

  font-weight: 400;
  color: #000000;
}

.selectClass-class {
  padding: 19px 0 0 26px;
  width: 761px;
  height: 196px;
  display: grid;
  grid-template-columns: repeat(5, 104px);
  grid-template-rows: repeat(3, 20px);
  grid-column-gap: 44px;
  grid-row-gap: 30px;
}

.vanCheckbox {
  width: 104px;
  height: 20px;
}

.classTimes-box {
  display: flex;
  align-items: center;
  margin-left: 32px;
  margin-bottom: 10px;
}

.classTimes-txt {
  width: 90px;
  font-size: 22px;

  font-weight: 400;
  color: #555555;
}

.publicInput-classTimes {
  width: 669px;
  height: 50px;
  border: 1px solid #757575;
  border-radius: 10px;
}

.publicInput-moduleBox {
  width: 100%;
}

.publicInput-module {
  margin-left: 60px;
  float: right;
  width: 700px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
  margin-top: 10px;
}

.publicInputModule {
  width: 685px;
  font-size: 20px;

  font-weight: 400;
  color: #555555;
  margin-left: 17px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
  background-color: transparent;
  border: 0px;
  outline: none;
}

/* 自定义placeholder的默认样式 */
input::-webkit-input-placeholder {
  color: #666666;
}

.uploadTxt {
  font-size: 16px;

  font-weight: 400;
  color: #999999;
}

.fileFrame {
  width: 1400px;
  height: 110px;
  border: 1px solid #757575;
  border-radius: 10px;
  padding: 20px 30px;
  box-sizing: border-box;
}

.noFile {

  font-weight: 400;
  font-size: 18px;
  color: #555555;
  opacity: 0.5;
}

.fileName {
  font-size: 22px;

  font-weight: 400;
  color: #555555;
}

.uploadTime {
  font-size: 18px;

  font-weight: 400;
  color: #999999;
}

.btnAffirm {
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
  line-height: 195px;
  text-align: center;
  line-height: 50px;
}

.btnPopupAffirm {
  position: absolute;
  bottom: 20px;
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
  line-height: 195px;
  text-align: center;
  line-height: 50px;
}

.classTimes-box {
  display: flex;
  align-items: center;
  margin-left: 32px;
  margin-bottom: 10px;
}

.classTimes-txt {
  width: 90px;
  font-size: 22px;

  font-weight: 400;
  color: #555555;
}

.publicInput-classTimes {
  width: 669px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
}

.publicInput-classTimes1 {
  padding-left: 21px;
  width: 669px;
  height: 40px;
  border: 1px dashed #757575;
  border-radius: 10px;
  box-sizing: border-box;
}

.publicInput-classTimes2 {
  padding-left: 21px;
  width: 761px;
  height: 40px;
  border: 1px dashed #757575;
  border-radius: 10px;
  box-sizing: border-box;
}

.publicInput-catalogue {
  width: 761px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
}

.btnAffirm-box {
  margin-left: 10px;
  width: 30px;
  height: 30px;
}

.defineIcon {
  width: 30px;
  height: 30px;
  display: none;
}

.defineIcon1 {
  margin-left: 10px;
  width: 21px;
  height: 21px;
}

.defineIcon2 {
  margin-left: 10px;
  width: 30px;
  height: 30px;
  opacity: 0;
}

.deleteIcon {
  width: 21px;
  height: 21px;
}

.addTxt {
  margin-left: 9px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.pushButton {
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
}

.gradediv {
  width: 100%;
  height: 50px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 20px;
  overflow: hidden;
  overflow-x: scroll;
  white-space: nowrap;
}

.gradediv_color1 {
  color: #349afe;
}

.gradediv_color2 {
  color: #000000;
}

.gradediv_class {
  height: 200px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 20px;
  margin-top: 22px;
  margin-left: 33px;
  overflow: auto;
}

.gradediv_classdiv {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin-bottom: 33px;
  margin-right: 44px;
  cursor: not-allowed;
}

.gradediv_classimg {
  width: 20px;
  height: 20px;
}

.gradediv_classtxt {
  font-size: 18px;
  font-weight: 400;
  color: #555555;
  margin-left: 10px;
}

.popup-deleClassNum {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.5);
}

.popup-content {
  position: relative;
  width: 760px;
  height: 300px;
  background: #ffffff;
  border-radius: 20px;
}

.popup-close {
  width: 23px;
  height: 23px;
  position: absolute;
  top: 24px;
  right: 24px;
}

.popup-txt {
  font-size: 30px;
  color: #000000;
}

.courseData-box {
  width: 1740px;
  height: calc(100vh - 215px);
  overflow: auto;
  padding: 30px 50px;
  box-sizing: border-box;
}

.echarts-box {
  height: 341px;
  border-bottom: 1px solid #bfbfbf;
}

.courseData-block {
  width: 12px;
  height: 26px;
  background: #3096fb;
}

.courseData-title {
  margin-left: 20px;
  font-size: 20px;

  font-weight: 400;
  color: #000000;
  line-height: 20px;
}

.echartsPieBox {
  margin-top: 27px;
}

.courseInformation {
  width: 820px;
  height: 432px;
  padding: 30px 59px 40px 10px;
  box-sizing: border-box;
  border-right: 1px solid #bfbfbf;
}

.teachingData-contentBox {
  margin-top: 20px;
}

.teachingData-contentBox1 {
  margin-top: 10px;
}

.teachingData-content {
  width: 236px;
  height: 170px;
  background: #eaf4fd;
  border-radius: 10px;
  padding: 43px 0;
  box-sizing: border-box;
}

.barChart-box {
  margin-top: 20px;
  width: 751px;
  height: 390px;
}

.basicData-txt {
  font-size: 20px;

  font-weight: 400;
  color: #555555;
}

.basicData-num {
  font-size: 60px;

  font-weight: 400;
  color: #3096fb;
  line-height: 60px;
}
</style>
